<template>
    <div class="nav" v-c:flex-column="!row">
        <slot>
            <nav-item v-for="(item, index) in items" :key="index" v-bind="item"/>
        </slot>
    </div>
</template>

<script>
    export default {
        components: {
            'nav-item': require('./NavItem').default,
        },

        props: {
            items: Array,
            row: {type: Boolean, default: false},
        },
    };
</script>